import { Button, Intent } from "@blueprintjs/core";
import React, { Fragment, useEffect } from "react";
import logo from "../../assets/logo.png";
import PersonalQuestion from "./InProgressSession/PersonalQuestion";
import FadeIn from "react-fade-in";

const PersonalQuestions = ({
  personalQuestions,
  handleChangeAnswer,
  finishPersonalData,
  personalAnswers,
}) => {
  const handleResponses = (e) => {
    let question = e.target.name;
    let answer = e.target.value;
    handleChangeAnswer(question, answer);
  };

  useEffect(() => {
    if (!personalQuestions) {
      finishPersonalData();
    }
    if (personalAnswers) {
      finishPersonalData();
    }
    // eslint-disable-next-line
  }, []);

  if (personalQuestions) {
    return (
      <Fragment>
        {personalQuestions.map((question) => (
          <PersonalQuestion
            handleResponses={handleResponses}
            question={question.question}
            answers={question.options}
            reference={question.id}
          />
        ))}
        <FadeIn>
          <div className="text-center margin-bottom-large">
            <Button
              className="margin-top-large"
              text="Next"
              icon="tick-circle"
              onClick={finishPersonalData}
              intent={Intent.SUCCESS}
            />
          </div>
        </FadeIn>
        <div className="logo-container-bottom-left">
          <img src={logo} alt="logo" className="logo-large" /> &nbsp; &nbsp;
          <div>
            <span className="logo-title-large">VisualSense</span> <br />
            <span>&nbsp; Lyon, France</span>
          </div>
        </div>
      </Fragment>
    );
  } else {
    return <></>;
  }
};

export default PersonalQuestions;
